import { useTagStore } from '~/stores/tag'

import type { Influencer } from '~/types/influencer'

type AvailableMarkType = 'free' | 'new'

export function useCuratorProfileMarkType(influencerTags: Influencer['tags']) {
  const { GET_TAGS_FROM_IDS } = useTagStore()

  const availableMarks = ref<AvailableMarkType[]>(['free', 'new'])
  const markTags = computed(() =>
    GET_TAGS_FROM_IDS(influencerTags?.identity.influencer_mark ?? []),
  )

  const type = computed<AvailableMarkType | undefined>(() => {
    for (const markName of availableMarks.value) {
      const tag = markTags.value.find((tag) => tag.name === markName)

      if (tag) return tag.name as AvailableMarkType
    }
    return undefined
  })

  return { type }
}
